import { GameConfig } from '@models/game-config.interface';
import { SceneKey } from '@models/scene-keys';
import { AdminAPIService } from '@services/api/AdminAPIService';
import { GameConfigService } from '@services/core/GameConfigService';
import { loadThemeAssets } from '@utils/theme-assets.utils';
import Phaser from 'phaser';

export default class AdminPreload extends Phaser.Scene {
  private adminAPI = new AdminAPIService();

  constructor() {
    super(SceneKey.AdminPreload);
  }

  preload() {}

  async create() {
    const configService = new GameConfigService();
    try {
      const gameConfig: GameConfig = await this.adminAPI.fetchGameConfig(
        configService.sessionParams,
      );
      configService.setGameConfig(gameConfig);
      // Load assets
      loadThemeAssets(this, gameConfig.stage);
      this.load.once('complete', () => {
        this.scene.start(SceneKey.AdminLayout);
      });
      this.load.start();
    } catch (err) {
      console.error('[AdminLayout] fetchStage failed', err);
      this.scene.start(SceneKey.Error);
    }
  }
}
